import { useEffect, useState } from "react";
import inputStyle from "../../styles/input.module.scss";
import LoadingDots from "../LoadingDots";

function ImagePreviewFrame({ src, alt, emptyLabel }) {
  const [status, setStatus] = useState("empty");

  useEffect(() => {
    if (!src) {
      setStatus("empty");
      return;
    }
    setStatus("loading");
  }, [src]);

  return (
    <div className={inputStyle.selectSwatchView}>
      {!src ? (
        <div className={inputStyle.previewEmpty}>{emptyLabel}</div>
      ) : (
        <>
          {status !== "ready" ? (
            <div className={inputStyle.previewLoader} aria-hidden="true">
              {status === "error" ? (
                <p className={inputStyle.previewEmpty}>Preview unavailable</p>
              ) : (
                <LoadingDots dotsClassName={inputStyle.previewLoaderDots} />
              )}
            </div>
          ) : null}
          <img
            key={src}
            className={inputStyle.droppedImage}
            src={src}
            alt={alt}
            onLoad={() => setStatus("ready")}
            onError={() => setStatus("error")}
            ref={(image) => {
              if (image?.complete && image.naturalWidth > 0) {
                setStatus("ready");
              }
            }}
          />
        </>
      )}
    </div>
  );
}

export default ImagePreviewFrame;
